import { Component, ComponentInterface, Element, h, Host, JSX, Listen, Prop } from '@stencil/core';
import { transformTagNames } from '../../../global/transform-tag-name';
import { SharedDirectionService } from '../../../global/workbench-global';
import { applyClass } from '../../../utils/apply-class';

/**
 * @slot - content placed in the list item
 * @slot icon - optional wb-icon element
 */
@Component({
  tag: 'wb-list-item',
  styleUrl: 'item.scss',
  shadow: true,
})
export class ListItemComponent implements ComponentInterface {
  @Element()
  public el: HTMLWbListItemElement;

  /** @internal if present sets the direction of the element to rtl */
  @Prop({ reflect: true, mutable: true })
  public isRtl: boolean = false;

  /** Font size, set by the parent `wb-list` */
  @Prop({ reflect: true })
  public size: 's' | 'm' | 'l' = 'm';

  /** Font size responsiveness */
  @Prop({ reflect: true })
  public static: boolean = false;

  @Listen('wbdirchange', { target: 'document' })
  public updateDirection() {
    this.isRtl = SharedDirectionService.isRtl;
  }

  private TagNames = transformTagNames(this, 'wb-list-item', ['wb-list', 'wb-text']);

  public connectedCallback() {
    this.updateDirection();
  }

  private onIconSlotChange = () => {
    const hasIcon = Boolean(this.el.querySelector('[slot="icon"]'));
    applyClass(this.el, 'has-icon', hasIcon);
  };

  public render(): JSX.Element {
    const { WbList, WbText } = this.TagNames;
    const variant = this.el.closest<HTMLWbListElement>(WbList).variant;

    return (
      <Host class="wb-list-item" role="listitem" variant={variant}>
        <slot name="icon" onSlotchange={this.onIconSlotChange} />
        <WbText size={this.size} static={this.static}>
          <slot />
        </WbText>
      </Host>
    );
  }
}
